import { client } from "api";
import { Contact } from "models/Contact";
import { CustomerReference } from "models/Order";

export type CreateCustomerReferenceRequest = { orderId: string; contact: Contact | null };
export type CreateCustomerReferenceResponse = CustomerReference;

export const createCustomerReference = ({ orderId, ...params }: CreateCustomerReferenceRequest) =>
  client
    .post<CreateCustomerReferenceResponse>(`/order/${orderId}/customer-reference`, params)
    .then((res) => res.data);
